import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isFetchingAddress: false,
  isUpdatingAddress: false,
  isValidatingAuth: false,

  result: [],
};

const authMemberReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

  case types.GET_AUTH_MEMBER_REQUEST:
    return {
      ...state,
      result: [],
      isFetching: true,
    };

  case types.GET_AUTH_MEMBER_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isFetching: false,
    };

  case types.GET_AUTH_MEMBER_FAILURE:
    return {
      ...state,
      result: [],
      isFetching: false,
      };

  case types.UPDATE_ADDRESS_PHONE_NUM_REQUEST:
    return {
      ...state,
      result: [],
      isUpdatingAddress: true,
    };

  case types.UPDATE_ADDRESS_PHONE_NUM_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isUpdatingAddress: false,
    };

  case types.UPDATE_ADDRESS_PHONE_NUM_FAILURE:
    return {
      ...state,
      result: [],
      isUpdatingAddress: false,
      };

  case types.VALIDATE_AUTH_REQUEST:
    return {
      ...state,
      result: [],
      isValidatingAuth: true,
    };

  case types.VALIDATE_AUTH_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isValidatingAuth: false,
    };

  case types.VALIDATE_AUTH_FAILURE:
    return {
      ...state,
      result: [],
      isValidatingAuth: false,
    };


  default:
    return state;
  }
};

export default authMemberReducer;
